import React, { useContext } from 'react'

const VehicleKeptOvernightQuestion = ({ requestContext, reqVehicleClass }) => {
    const vehicleContext = useContext(requestContext)
    var addressFields = vehicleContext[reqVehicleClass]?.policyAddressFields

    return (
        <>
            <div className='col-xl-12 justify-content-center'>
                <div className="row form-group form-group-sm align-items-center mt-4">
                    <p className="col-7 col-sm-12 text-primary fw-bold mb-2 mb-md-0" style={{ fontSize: '16px' }}>
                        Will all of your vehicle(s) be kept overnight at {addressFields?.address1} {addressFields?.city}, {addressFields?.state} {addressFields?.zip?.slice(0, 5)}?*
                    </p>
                    <div className="col-5 col-sm-12">
                        {['Yes', 'No'].map((value, id) => {
                            return (
                                <div key={id} className="radio-inline form-check form-check-inline">
                                    <label className="form-check-label text-dark" style={{ fontSize: '14px' }}>
                                        <input type={"radio"} className="form-check-input" value={value}
                                            checked={vehicleContext[reqVehicleClass]?.driverAssignment?.keptOvernight == value}
                                            onChange={() => { vehicleContext?.updateVehiclesKeptOvernight("keptOvernight", value) }}
                                        />{value}
                                    </label>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default VehicleKeptOvernightQuestion